import StorageService from "../services/StorageService"
import Registry from "../utils/Registry";

function onSubmit(orderId) {
  $(".js-customer-survey-form").on("submit", function() {
    $("#customer-survey-rating").addClass("hidden")
    $("#customer-survey-thanks").removeClass("hidden")
    StorageService.setItem("customerSurvey", orderId)
  })
}

export default {
  init: function () {
    // orderId published by orderInfoWidget
    Registry.get('orderId').then(orderId => {
      if (StorageService.getItem("customerSurvey") === String(orderId)) {
        return
      }

      $(".js-customer-survey").removeClass("hidden")
      onSubmit(orderId)
    })
  }
}
